export const CAROUSEL_TYPE = 2;
export const INTERNATIONAL = 'INTL';
export const GROUND = 'GROUND';

export enum ProductView {
    Full,
    ShortInfo
}
